import produce from 'immer'
import { IGuide } from 'shared/models/Guide'
import {
  GUIDES_FETCH_REQUESTED,
  GUIDES_FETCH_SUCCESS,
  GUIDES_FETCH_FAILED,
  GUIDE_COMPLETED_FAILED,
  GUIDE_COMPLETED_SUCCESS,
  GUIDE_COMPLETED_REQUESTED,
  GUIDES_COMPLETED_REQUESTED,
  GUIDES_RETAKE,
} from './actionTypes'
import { GuidesActionTypes } from './types'

const initialState = {
  data: null as IGuide[] | null,
  loading: false,
  error: null,
  isRetakeGuide: false,
}

const reducer = produce((state = initialState, action: GuidesActionTypes) => {
  switch (action.type) {
    case GUIDES_FETCH_REQUESTED:
      state.loading = true
      return

    case GUIDES_FETCH_SUCCESS:
      state.loading = false
      state.data = action.payload
      state.isRetakeGuide = false
      return

    case GUIDES_FETCH_FAILED:
      state.loading = false
      state.error = action.payload
      return

    case GUIDE_COMPLETED_REQUESTED:
      state.loading = true
      return

    case GUIDE_COMPLETED_SUCCESS:
      state.loading = false
      return

    case GUIDE_COMPLETED_FAILED:
      state.loading = false
      state.error = action.payload
      return

    case GUIDES_COMPLETED_REQUESTED:
      state.loading = true
      return

    case GUIDES_RETAKE:
      const guides = [...state.data] as IGuide[]
      const removed = guides.filter(
        (x) => !action.payload.includes(x.tutorialId)
      )

      state.loading = false
      state.data = removed
      state.isRetakeGuide = true
      return

    default:
      return state
  }
})

export default reducer
